<template>
	<div class="filter-sort">
		<input placeholder="search last name (all)" type="text" v-model="searchTerm" /> 
		<span>OR</span>
		<div class="all-buttons-filter">
			<button 
				v-for="session in sessions" 
				:key="session.id"
				v-on:click="activeSession = session.id" 
				v-bind:class="{ 'disabled': currentSession !== session.id }"
			>{{ session.label }}</button>
		</div>
	</div>
	<div class="m-list">
		<div v-for="mentor in mentorsFiltered" :key="mentor.id" class="mentor" :style="mentorBgStyle(mentor)">
			<div class="m-bg">
				<SingleMentor :mentor="mentor" />
			</div>
		</div>
	</div>
</template>

<script>
import SingleMentor from './SingleMentor.vue'

export default {
	props: ['mentors'],
	components: { SingleMentor },
	data() {
		return {
			searchTerm: '',
			activeSession: null
		}
	},
	computed: {
		sessions() {
			const startYear = 2021
			const endYear = new Date().getFullYear()
			const list = []
			for (let year = startYear; year <= endYear; year++) {
				list.push({ id: `${year}-Spring`, label: `Spring ${year.toString().slice(-2)}` })
				list.push({ id: `${year}-Fall`, label: `Fall ${year.toString().slice(-2)}` })
			}
			return list
		},
		defaultSession() {
			const now = new Date()
			const season = now.getMonth() < 6 ? 'Spring' : 'Fall'
			return `${now.getFullYear()}-${season}`
		},
		currentSession() {
			return this.activeSession || this.defaultSession
		},
		mentorsFiltered() {
			if (this.searchTerm !== '') {
				return this.mentors.filter(mentor => 
					mentor['name-last'].toLowerCase().match(this.searchTerm.toLowerCase())
				)
			}
			return this.mentors.filter(mentor => 
				mentor['sessions'].includes(this.currentSession) || mentor['sessions'].length < 1
			)
		}
	},
	methods: {
		mentorBgStyle(mentor) {
			if (mentor.headshots && mentor.headshots[0]) {
				return `background-image:url(https://ucarecdn.com/${mentor.headshots[0]}/-/stretch/fill/-/resize/210x/-/quality/lightest/-/blur/66); background-size: cover; background-position: center center`
			}
			return false
		}
	}
}
</script>